<template>
  <v-container>
    <v-row class="text-center" v-show="loading">
      <v-progress-circular
        class="mx-auto loader"
        indeterminate
        color="orange"
        size="75"
      ></v-progress-circular>
    </v-row>

    <v-row v-show="!loading">
      <v-col cols="9" md="6">
        <v-text-field
          v-model="term"
          label="Search"
          append-icon="mdi-magnify"
          @input="search"
        ></v-text-field>
      </v-col>
      <v-col cols="3" offset-md="3" class="text-right">
        <v-btn class="mx-2" fab dark color="orange" @click="dialog = true">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-show="!loading">
      <v-col
        cols="12"
        md="3"
        offest-md="3"
        v-for="profile in filtered"
        :key="profile.id"
      >
        <v-card>
          <div class="text-center">
            <v-avatar size="150" class="mt-5 dark-background">
              <v-img v-if="profile.picture" :src="profile.picture"></v-img>
              <span v-else class="white--text display-2">
                {{ profile.firstName.substring(0, 1) }}
                {{ profile.lastName.substring(0, 1) }}
              </span>
            </v-avatar>
          </div>
          <v-card-title class="d-block text-center">
            {{ profile.firstName }} {{ profile.lastName }}
          </v-card-title>
          <v-card-subtitle class="d-block text-center">
            {{ formatDate(profile.dateOfBirth) }}
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange" block text @click="viewProfile(profile)">
              View Profile
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text"
          >Create Profile</v-card-title
        >
        <v-card-text>
          <v-file-input
            accept="images/*"
            v-model="picture"
            label="Picture"
          ></v-file-input>
          <v-text-field
            v-model="firstName"
            label="First Name"
            type="text"
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            label="Last Name"
            type="text"
          ></v-text-field>
          <v-text-field
            v-model="dateOfBirth"
            label="Date of Birth"
            type="date"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialog = false">Cancel</v-btn>
          <v-btn text color="orange" @click="save">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackText }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import firebase from "@/firebase";

export default {
  name: "Profiles",
  data() {
    return {
      dateOfBirth: null,
      dialog: false,
      filtered: [],
      firstName: null,
      lastName: null,
      loading: true,
      picture: null,
      profile: {},
      saving: false,
      snackbar: false,
      snackText: null,
      storage: firebase.storage.ref(),
      term: null
    };
  },
  computed: {
    ...mapGetters({
      profiles: "profiles/getProfiles"
    })
  },
  methods: {
    ...mapActions({
      listProfiles: "profiles/listProfiles",
      createProfile: "profiles/createProfile",
      deleteProfile: "profiles/deleteProfile",
      updateProfile: "profiles/updateProfile"
    }),
    formatDate(date) {
      return moment(date).format("LL");
    },
    async save() {
      if (!this.firstName || !this.lastName || !this.dateOfBirth) {
        this.snackbar = true;
        this.snackText =
          "The First Name, Last Name, and Date of Birth fields are required";
        return;
      }
      this.saving = true;
      const id = await this.createProfile({
        dateOfBirth: this.dateOfBirth,
        firstName: this.firstName,
        lastName: this.lastName,
        picture: this.picture
      });
      await this.listProfiles(firebase.auth.currentUser.uid);
      this.$router.push({
        name: "questionnaire",
        params: { id }
      });
    },
    search() {
      this.filtered = this.profiles.filter(p => {
        const name = `${p.firstName.toLowerCase()} ${p.lastName.toLowerCase()}`;
        return (
          name.includes(this.term.toLowerCase()) ||
          p.dateOfBirth.includes(this.term)
        );
      });
    },
    viewProfile(profile) {
      this.$router.push({ name: "profile", params: { id: profile.id } });
    }
  },
  async mounted() {
    await this.listProfiles(firebase.auth.currentUser.uid);
    this.filtered = this.profiles;
    this.loading = false;
  }
};
</script>

<style scoped>
.loader {
  margin-top: 20%;
}
</style>
